import { Box, styled } from '@mui/material'

export const StyledAnchor = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'offset',
})
(({ offset }) => ({
  scrollMarginTop: offset
}))
